const ACTIONS = {
  CHANGE_NAME: "CHANGE_NAME",
  FETCH_PRODUCTS: "FETCH_PRODUCTS",

  SIGN_IN: "SIGIN_IN",
  SIGN_OUT: "SIGN_OUT",
  GET_TOKEN: "GET_TOKEN",
  GET_USER: "GET_USER",

  GET_PROSPECTS: "GET_PROSPECTS",

  // UTILS
  DEL_Edit: "DEL_Edit",
  UPDATE_EDIT: "UPDATE_EDIT",
  IS_SEARCH: "IS_SEARCH",
  UPDATE_IS_VIEWED: "UPDATE_IS_VIEWED",
};
export default ACTIONS;
